import type { FC } from 'react';
import { useEffect } from 'react';

import { addUFOCustomMark } from '@atlaskit/react-ufo/custom-mark';

import { Attribution } from '@confluence/error-boundary/entry-points/Attribution.ts';
import { withTransparentErrorBoundary } from '@confluence/error-boundary/entry-points/withErrorBoundary.ts';

type PageLoadMarkFMPProps = {
	timestamp?: number;
};

const PageLoadMarkFMPComponent = ({ timestamp }: PageLoadMarkFMPProps) => {
	useEffect(() => addUFOCustomMark('fmp', timestamp), [timestamp]);

	return null;
};

export const PageLoadMarkFMP: FC<PageLoadMarkFMPProps> = withTransparentErrorBoundary({
	attribution: Attribution.BACKBONE,
})(PageLoadMarkFMPComponent);
